import { render, staticRenderFns } from "./ThePagination.vue?vue&type=template&id=7cfd13a5&scoped=true&"
import script from "./ThePagination.vue?vue&type=script&lang=js&"
export * from "./ThePagination.vue?vue&type=script&lang=js&"
import style0 from "./ThePagination.vue?vue&type=style&index=0&id=7cfd13a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfd13a5",
  null
  
)

export default component.exports